// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"Toggle_toggleSwitch__wy-Qp","slider":"Toggle_slider__Rnkjm","yellow":"Toggle_yellow__w0XG-"};